import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Grid, useGridMemory } from 'jrgrid';

import { Loader } from '../../../components/Loader';
import Navbar from '../../../components/Navbar';
import { receivingPageColumns } from '../utils';
import { pageReceivingRequested, pageRequests } from '../api';
import { useSelector } from 'react-redux';

export const RequestsPage = () => {
  const [refresh, setRefresh] = React.useState<boolean>(true);
  const { user } = useSelector((state: any) => ({
    user: state.user,
  }));
  const gridMem = useGridMemory();
  const gridFilter = [
    {
      id: 'status',
      type: 'string',
      operand: 'and',
      value: 'Requested',
    },
    {
      id: 'requestingDepartment',
      type: 'string',
      operand: 'and',
      value: `${user.currentRole.departmentAbbreviation}`,
    },
    {
      id: 'fulfillingDepartment',
      type: 'string',
      operand: 'and',
      value: `${user.currentRole.departmentId}`,
    },
  ];

  const renderGrid = () => {
    if (refresh) {
      setTimeout(() => {
        setRefresh(false);
      }, 500);
      return <Loader title='Reloading Grid..' />;
    } else {
      // Don't change order, query is hardcoded in resolver to look for these filters in this order.
      const filter = [];

      return (
        <Grid
          amount={20}
          columns={receivingPageColumns}
          query={pageReceivingRequested}
          queryName='pageRequestsWithCustomQuery'
          defaultSortField='id'
          globalFilters={[...gridFilter, ...filter]}
          gridMemory={gridMem}
          csv={user.currentRole.isAdmin}
        />
      );
    }
  };

  return (
    <>
      <Navbar />
      <div className='container-fluid'>
        <Row>
          <Col md={8}>
            {/* {filterButtonsReqItem.map((item, index) => {
                  return (
                    <Button
                      key={index}
                      className='mt-3 mb-3 ml-2'
                      onClick={() => {
                        setGridFilter(item.filter);
                      }}>
                      {item.title}
                    </Button>
                  );
                })} */}
          </Col>
          <Col md={4}>
            <h3 className='mt-3 mb-3 ml-2 mr-2 float-right'>Incoming Requests</h3>
          </Col>
        </Row>
        <div className='ml-2 mr-2'>{renderGrid()}</div>
      </div>
    </>
  );
};
